export const ContentListingType = {
  STATIC: 'Static',
  INTERACTIVE: 'Interactive',
};

export const ListingItemType = {
  FILE: 'File',
  LINK: 'Link',
  FOLDER: 'Folder',
  QUIZ: 'Quiz',
  EMBEDDED: 'Html/Embedded',
  EXAM: 'Exam',
};

export const ContentListingInteractionType = {
  TAKE_QUIZ: 'Take Quiz',
  DOWNLOAD: 'Download',
  VIEW: 'View',
  COMPLETE: 'Complete',
};

export const QuizFeedbackMode = {
  NONE: 'None',
  INDICATE_CORRECTNESS: 'IndicateCorrectness',
  SHOW_CORRECT_ANSWERS: 'ShowCorrectAnswers',
};